  var imgswiper = new Swiper(".banner_slider", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
$(document).ready(function() {
  function updatePrices($input) {
    var variantPrice = $input.data('price');
    var camparePrice = $input.data('campare-price');

    var $wrapper = $input.closest('.ct_card-wrapper');

    $wrapper.find('.card_product_price_class').text(variantPrice);
    $wrapper.find('.card_product_price_camp').text(camparePrice || '');
  }

  $('input[type="radio"]:checked').each(function() {
    updatePrices($(this));
  });

  $('input[type="radio"]').on('change', function() {
    updatePrices($(this));
  });
});


  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ct-card-variants input[type='radio']").forEach(function(input) {

    function updateVariant() {
      const card = input.closest('.ct_variant_pack_card');
      if (!card) return;

      // Get the actual price from the card
      const priceSpan = card.querySelector('span[data-price_data]');
      const price = priceSpan?.dataset.price_data || '';
      const comparePrice = priceSpan?.dataset.comparePrice || '';

      // Update price display
      const wrapper = input.closest('.ct_card-wrapper');
      wrapper.querySelector('.card_product_price_class').textContent = price;
      wrapper.querySelector('.card_product_price_camp').textContent = comparePrice;

      // Update hidden input (variant ID)
      const variantIdInput = wrapper.querySelector('.product-variant-id');
      variantIdInput.value = card.dataset.variantId || '';

      // Enable/disable add to cart
      const addToCartBtn = wrapper.querySelector("button[name='add']");
      if (!input.classList.contains('disabled')) {
        addToCartBtn.removeAttribute("disabled");
      } else {
        addToCartBtn.setAttribute("disabled", "disabled");
      }
    }

    // Run on page load if selected
    if (input.checked) updateVariant();

    // Run on change
    input.addEventListener('change', updateVariant);
  });
});

/*// Img-text-block //*/
document.addEventListener("DOMContentLoaded", function () {
var slideItems = document.querySelectorAll('.img-text-block_slider .swiper-slide');
if (slideItems.length > 2) {
  var swiper = new Swiper('.img-text-block_slider', {
    loop: false,  
    slidesPerView: 2,  
    spaceBetween: 5,
    navigation: {
      nextEl: '.img-text-block_heading_arrows .img-text-block_arrow_next', 
      prevEl: '.img-text-block_heading_arrows .img-text-block_arrow_prev',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 17
      },
    }
  });
}
var slideItems1 = document.querySelectorAll('.testimonial_slider .swiper-slide');
if (slideItems1.length > 2) {
  var swiper = new Swiper('.testimonial_slider', {
    loop: false,  
    slidesPerView: 1.35,  
    spaceBetween: 10,
    navigation: {
      nextEl: '.testimonial_header .img-text-block_arrow_next', 
      prevEl: '.testimonial_header .img-text-block_arrow_prev',
    },
    breakpoints: {
      575: {
        slidesPerView: 1.9,
        spaceBetween: 20
      },
      769: {
        slidesPerView: 2.9,
        spaceBetween: 20
      },
      1025: {
        slidesPerView: 3.9,
        spaceBetween: 20
      },
    }
  });
}
var slideItems3 = document.querySelectorAll('.blog__posts_swiper .swiper-slide');
if (slideItems3.length > 2) {
  var swiper = new Swiper('.blog__posts_swiper', {
    loop: false,
    slidesPerView: 1,  
    spaceBetween: 20,
    navigation: {
      nextEl: '.main_blog_section .img-text-block_arrow_next', 
      prevEl: '.main_blog_section .img-text-block_arrow_prev',
    },
    breakpoints: {
      577: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20
      },
    }
  });
}
});

function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    const acc_main = accordion.closest('[data-tab-acc-main-content]') || null;
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            if(acc_main){
              const main_accodin = acc_main.querySelectorAll("[js-acc-item]");
              main_accodin.forEach((accordion) => closeAccordion(accordion));
               openAccordion(e.target.closest('[js-acc-item]'));
            }else{
               accordions.forEach((accordion) => closeAccordion(accordion));
               openAccordion(e.target.closest('[js-acc-item]'));
            }
            
          }
        };
    }
  });   
}
faq_taggol()
// Inner Tabs
$('.pdp-tabs_content_title').click(function(){
    $('.pdp-tabs_content_tabs_item').removeClass('active');
    $(this).parent().addClass('active');
});

document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
  let activeMenuItem = null; 
  menuItems.forEach((item, index) => {
    const detailsElement = item.querySelector('details');
    if (!detailsElement) {
      return;
    }
    item.addEventListener('mouseenter', () => {
      if (activeMenuItem && activeMenuItem !== item) {
        const previousDetailsElement = activeMenuItem.querySelector('details');
        if (previousDetailsElement) previousDetailsElement.removeAttribute('open');
      }
      detailsElement.setAttribute('open', true);
      activeMenuItem = item; 
    });

    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!item.matches(':hover')) {
          detailsElement.removeAttribute('open');
          if (activeMenuItem === item) activeMenuItem = null; 
        } 
      }, 500); // Adjust delay as needed
    });
  });
});
$(document).on('click','.copied_content',function(){
  $('.copied').text('Copy Code');
  $(this).parents('.pdp_coupon_content').find('.copied').text('Copied!');
});
function copyToClipboard(element) {  
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();  
}

$(document).ready(function () {
  const updateActiveClass = () => {
    $('.ct_variant_pack_of .variant-option').removeClass('is_active variant_active');
    const checkedInput = $('.ct_variant_size input:checked');    
    if (checkedInput.length) {
      const checkedValue = $.trim(checkedInput.val());
      const matchingOption = $('.ct_variant_pack_of .variant-option').filter(function () {
        return $.trim($(this).attr('data-variant-options')) === checkedValue;
      });
      matchingOption.addClass('is_active variant_active');
    }
  };
  // Run once on page load
  updateActiveClass();
  // Run when size input changes
  $(document).on('change', '.ct_variant_size input', updateActiveClass);
  // Run when any variant changes (common custom event)
  $(document).on('variant:changed variantChange', updateActiveClass);
  // Fallback: if theme doesn't trigger above, listen to form change
  $(document).on('change', 'form[action*="/cart/add"]', updateActiveClass);
});